import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AccessLevelModel } from '../../models/access-level/access-level';

@Injectable({
  providedIn: 'root'
})
export class CommonServiceService {

  private accessLevel = new BehaviorSubject<AccessLevelModel | null>(null);

  accessLevel$ = this.accessLevel.asObservable();

  changeAccessLevel(accessLevel: AccessLevelModel | null) {
    this.accessLevel.next(accessLevel)
  }

}
